import { useEffect, useRef, useState } from 'react';
import { promotionInfoStore } from '@/website/store/promotion/promotionInfoStore';

type CommonTopPromotionCountDownViewProps = {};
const CommonTopPromotionCountDownView = (props: CommonTopPromotionCountDownViewProps) => {
  const [seconds, setSeconds] = useState<number>(0);
  const [minutes, setMinutes] = useState<number>(0);
  const [hours, setHours] = useState<number>(0);
  const [days, setDays] = useState<number>(0);
  const timerRef = useRef(null);
  const {
    state: { promotionInfo },
  } = promotionInfoStore();
  const [customStyles, setCustomStyles] = useState({
    title: '',
    titleColor: '#ffffff',
    fontSize: '16px',
    backgroundColor: '#0E35D1',
  });

  useEffect(() => {
    clearInterval(timerRef.current);

    if (promotionInfo) {
      const { end_date, banner_settings } = promotionInfo;
      const { top_banner_text, primary_color, top_banner_font_size, top_banner_bg_color } = banner_settings || {};
      setCustomStyles({
        title: top_banner_text,
        titleColor: primary_color || '#ffffff',
        fontSize: top_banner_font_size || '16px',
        backgroundColor: top_banner_bg_color || '#0E35D1',
      });
      if (end_date) {
        timerRef.current = setInterval(() => {
          const date = new Date(end_date);
          const now = new Date();
          const diffTime = Math.abs(date.getTime() - now.getTime());
          const remainingDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
          const remainingHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const remainingMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
          const remainingSeconds = Math.floor((diffTime % (1000 * 60)) / 1000);

          setDays(remainingDays);
          setHours(remainingHours);
          setMinutes(remainingMinutes);
          setSeconds(remainingSeconds);
        }, 1000);
      }
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [promotionInfo]);

  return !!promotionInfo?.end_date || !!customStyles?.title ? (
    <div className="z-50 flex w-full items-center justify-center py-2" style={{ backgroundColor: customStyles?.backgroundColor }}>
      <p className="px-4 text-center font-bold" style={{ color: customStyles?.titleColor, fontSize: customStyles?.fontSize }}>
        {customStyles?.title}
        {promotionInfo?.end_date && <span> - Ends in {`${days}d ${hours}h ${minutes}m ${seconds}s`}</span>}
      </p>
    </div>
  ) : null;
};

export default CommonTopPromotionCountDownView;
